/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { Orientation, pd } from '@airasia-phoenix/react-native/utils';

export const horizontalOrientation = new Orientation.Horizontal(
  4,
  1,
  pd.ref.space.spacing30.px / 2,
  0,
);
export const wrapOrientation = new Orientation.Wrap(
  0,
  0,
  pd.ref.space.spacing30.px,
  pd.ref.space.spacing20.px,
);
export const popularSearchesOrientation = new Orientation.Wrap(
  0,
  0,
  pd.ref.space.spacing10.px,
  pd.ref.space.spacing20.px,
);

/**
 * Popular filter chip group — Figma "Question group" specifies gap: 8px on both
 * axes. Pair this with chipPaddingHorizontal={0} on FilterChipSection, since
 * ChipGroupView's default 2px per-chip padding would otherwise push the
 * horizontal gap to 12px.
 */
export const popularFilterWrapOrientation = new Orientation.Wrap(
  0,
  0,
  pd.ref.space.spacing20.px,
  pd.ref.space.spacing20.px,
);
